import ContactAttributeType from "./ContactAttributeType";

const ContactAttribute = ({ type = false } = {}) => `
  id
  description
  typeId
  ${
    type
      ? `type {
      ${ContactAttributeType}
    }`
      : ""
  }
  updatedAt
`;

export default ContactAttribute;
